module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-2021-2.ea92b120.jpg";